// Author Lin
// Date 2021-03-17 16:14:14

class SithMesMstKam {
constructor({
        id = null,
        indicateKey = '',
        categoryId = '',
        enNetwork = '',
        enNetworkCode = '',
        cid = '',
        enActivityId = '',
        enElementCode = '',
        enElementName = '',
        enElementType = '',
        spiridonActivityId = '',
        spiridonActivityName = '',
        batchUnit = '',
        remark = ''}
= {}) {
    this.id = id;
    this.indicateKey = indicateKey;
    this.categoryId = categoryId;
    this.enNetwork = enNetwork;
    this.enNetworkCode = enNetworkCode;
    this.cid = cid;
    this.enActivityId = enActivityId;
    this.enElementCode = enElementCode;
    this.enElementName = enElementName;
    this.enElementType = enElementType;
    this.spiridonActivityId = spiridonActivityId;
    this.spiridonActivityName = spiridonActivityName;
    this.batchUnit = batchUnit;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesMstKam();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'indicateKey',
        label: 'label.sith.mst.sithMesMstKam.grid.indicateKey',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'categoryId',
        label: 'label.sith.mst.sithMesMstKam.grid.categoryId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enNetwork',
        label: 'label.sith.mst.sithMesMstKam.grid.enNetwork',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.mst.sithMesMstKam.grid.enNetworkCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'cid',
        label: 'label.sith.mst.sithMesMstKam.grid.cid',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.mst.sithMesMstKam.grid.enActivityId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enElementCode',
        label: 'label.sith.mst.sithMesMstKam.grid.enElementCode',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enElementName',
        label: 'label.sith.mst.sithMesMstKam.grid.enElementName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'enElementType',
        label: 'label.sith.mst.sithMesMstKam.grid.enElementType',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.mst.sithMesMstKam.grid.spiridonActivityId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.mst.sithMesMstKam.grid.spiridonActivityName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'batchUnit',
        label: 'label.sith.mst.sithMesMstKam.grid.batchUnit',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstKam.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    indicateKeyFilter : "",
    categoryIdFilter : "",
    enNetworkFilter : "",
    enNetworkCodeFilter : "",
    cidFilter : "",
    enActivityIdFilter : "",
    enElementCodeFilter : "",
    enElementNameFilter : "",
    enElementTypeFilter : "",
    spiridonActivityIdFilter : "",
    spiridonActivityNameFilter : "",
    batchUnitFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'indicateKeyFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.indicateKey',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'categoryIdFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.categoryId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'enNetworkFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.enNetwork',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enNetworkCodeFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.enNetworkCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'cidFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.cid',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enActivityIdFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.enActivityId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enElementCodeFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.enElementCode',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enElementNameFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.enElementName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enElementTypeFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.enElementType',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spiridonActivityIdFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.spiridonActivityId',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spiridonActivityNameFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.spiridonActivityName',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'batchUnitFilter',
        label: 'label.sith.mst.sithMesMstKam.filter.batchUnit',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'indicateKey',
        label: 'label.sith.mst.sithMesMstKam.entity.indicateKey',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'categoryId',
        label: 'label.sith.mst.sithMesMstKam.entity.categoryId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'enNetwork',
        label: 'label.sith.mst.sithMesMstKam.entity.enNetwork',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enNetworkCode',
        label: 'label.sith.mst.sithMesMstKam.entity.enNetworkCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'cid',
        label: 'label.sith.mst.sithMesMstKam.entity.cid',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enActivityId',
        label: 'label.sith.mst.sithMesMstKam.entity.enActivityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enElementCode',
        label: 'label.sith.mst.sithMesMstKam.entity.enElementCode',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enElementName',
        label: 'label.sith.mst.sithMesMstKam.entity.enElementName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'enElementType',
        label: 'label.sith.mst.sithMesMstKam.entity.enElementType',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spiridonActivityId',
        label: 'label.sith.mst.sithMesMstKam.entity.spiridonActivityId',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'spiridonActivityName',
        label: 'label.sith.mst.sithMesMstKam.entity.spiridonActivityName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'batchUnit',
        label: 'label.sith.mst.sithMesMstKam.entity.batchUnit',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.mst.sithMesMstKam.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {SithMesMstKam, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
